<template>
  <div id="app">
    <!--    <img alt="Vue logo" src="./assets/logo.png">-->
    <!--    <HelloWorld msg="Welcome to Your Vue.js App"/>-->
<!--    <img class="yui-header" src="./assets/banner-top-4.jpg" alt="">-->
    <section class="yui-section equity-1">
      <!--      <div class="section-title">
              <span>权益一</span>
            </div>-->
      <div class="section-desc">
        <span>1分钱购10元话费</span>
      </div>

      <div v-show="equity1Status==='00'||equity1Status==='02'||equity1Status==='03'||equity1Status===''">
        <div class="yui-cell">
          <label class="yui-cell-bd">
            <input type="tel"
                   name="phone"
                   id="phone"
                   v-model="rechargeMobileNo"
                   v-number-only
                   maxlength="11"
                   :disabled="joinDis||equity1Status==='03'"
                   @focus="phoneInputFocus"
                   placeholder="请输入充值手机号"
                   class="yui-input">
          </label>
        </div>
        <p v-show="equity1Status==='03'"
           class="equity1Status_03">{{ rechargeMobileNoLog }}充值中，请稍后查询结果</p>
        <p v-show="equity1Status==='02'"
           class="equity1Status_02">{{ rechargeMobileNoLog }}充值失败，请重新充值或更换手机号</p>
        <p v-show="equity1Status==='00'&&phoneErroeMsg"
           class="equity1Status_00">{{ phoneErroeMsg }}</p>

        <van-button type="primary"
                    round
                    size="small"
                    @click="prepaidRefill"
                    :disabled="joinDis||equity1Status==='03'||equity1Status==='02'"
                    class="equoty-bth-1">
          充值
        </van-button>

      </div>

      <div v-show="equity1Status==='01'" class="yui-equity1-success">
        <van-icon class="yui-icon" name="certificate"/>
        <p>{{ rechargeMobileNoLog }}</p>
        <p>充值成功</p>
      </div>
      <article class="yui_art">
        <h5 class="">活动规则</h5>
        <p>1.活动期间，新开通钱包用户，点击“立即1分购”使用钱包支付1分钱后，获得10元话费。</p>
        <p>2.在领取框内输入与本人新开通钱包的账号相同的手机号码，方可进行充值。请仔细填写，充错号码无法退回。</p>
        <p>3.活动数量有限，总计限量100000份，先到先得抢完即止。</p>
        <p>4.每位开通钱包用户仅可参与1次1分钱购活动。同一青岛地铁APP用户、身份证、手机号、手机设备，符合以上任一条件，均视为同一用户。</p>
        <p>5.请在活动期间完成权益领取使用，逾期将作废。</p>
        <p>6.月初月末充值繁忙，可能会出现延迟到账，一般30分钟内到账，最晚24小时到账。</p>
      </article>
      <article class="yui_art">
        <h5>免责声明</h5>
        <p>1.本活动以及其修改权、更新权均属青岛地铁APP。</p>
        <p>2.购买前请认真核对手机号码，携号转网号码、虚拟运营商号码暂不能提供充值服务。如遇话费充值失败问题，请致电4001570096进行咨询。</p>
        <p>3.如需帮助，请致电0532-55661111，进行咨询。</p>
      </article>
    </section>

    <!--    <section class="yui-section equity-2">
          <div class="section-title">
            <span>权益二</span>
          </div>
          <div class="section-desc">
            <span>话费满20元减15元大额满减</span>
          </div>
          <img v-show="(!joinDis)&&(equity2Status==='00'||equity2Status==='02')"
               class="sec-2-banner"
               src="./assets/sec-2-click.png"
               @click="toReceiveEquity2"
               alt="">
          <img v-show="(joinDis||equity2Status==='03')&&(equity2Status!=='01')"
               class="sec-2-banner"
               src="./assets/sec-2-click-dis.png"
               alt="">
          <div v-show="equity2Status==='01'" class="receive-success receive-success-2">

            <div class="receive-success-bd">
              <div class="yui-juanma">
                <div class="yui-hd">券码：</div>
                <div class="yui-bd" style="word-break:break-all; ">
                  {{equity2CouponCode}}
                </div>
                <van-button plain
                            round
                            class="yui-btn-fz"
                            type="info"
                            color="#24242a"
                            v-clipboard:copy="equity2CouponCode"
                            v-clipboard:success="equity2CouponCodeCopySuccess"
                            v-clipboard:error="equity2CouponCodeCopyError"
                            size="mini">复制
                </van-button>
              </div>
              <div class="yui-yxq">有效期至：{{equity2ExpireTime}}</div>
            </div>
            <img class="sec-2-geted-title" src="./assets/sec-2-geted-title.png" alt="">
          </div>
          <van-button type="primary"
                      round
                      @click="toCCB"
                      class="download-jianhang">前往建行手机银行→
          </van-button>

          <article class="yui_art">
            <h5 class="">活动规则</h5>
            <p>1.活动期间，新开通钱包用户点击“立即1分购”，支付1分钱后，获得满20元-15元话费大额满减兑换码。</p>
            <p>
              2.领取成功后，点击“前往建行手机银行”跳转至建行手机银行活动页面进行充值。无手机银行及未能正常跳转用户请自行下载建行手机银行，重新打开此页面，或进入建行手机银行-点击右下方“悦享生活”-点击“实惠青岛”-点击“青岛地铁APP钱包新用户专享活动”-在兑换码栏中输入兑换码-点击“立即充值””，充值20元及以上话费时方可使用。活动结束后，未使用兑换码自动失效。兑换码只可使用一次，一经使用概不退换。</p>
            <p>3.充值手机不记名、不挂失、即充即用，请用户妥善保管兑换码。</p>
            <p>4.如因用户未妥善保管兑换码而造成的损失，由用户自己承担。</p>
            <p>5.如果兑换码有使用问题请联系客服400-157-0096。</p>
          </article>
        </section>-->


    <!--    <article class="yui-tx">
          <h5>
            特别提醒
          </h5>
          <p>1.活动前已注册青岛地铁APP，但未开通钱包的用户，活动期间开通钱包，仍可参与本次活动。</p>
          <p>2.每位新开通钱包用户仅可参与1次1分钱购活动。</p>
          <p>3.填写充值手机号码时请仔细填写，充错号码无法退回。</p>
          <p>4.月初月末充值繁忙，可能会出现延迟到账，一般30分钟内到账，最晚24小时到账。</p>
        </article>-->

    <div style="height: 20vw;"></div>

    <footer class="footer-fix">
      <img v-show="fixBthStatus===0||fixBthStatus===7||fixBthStatus===6" @click="toPay" class="yui-fix-bth"
           src="./assets/btn-fix-1.png"
           alt="">
      <img v-show="fixBthStatus===2" class="yui-fix-bth" src="./assets/btn-fix-over.png" alt="">
      <img v-show="fixBthStatus===3" @click="toOpenWallet" class="yui-fix-bth" src="./assets/btn-fix-no-open.png"
           alt="">
      <img v-show="fixBthStatus===4" class="yui-fix-bth" src="./assets/btn-fix-wallet-opend.png" alt="">
<!--      <img v-show="fixBthStatus===10"
           class="yui-fix-bth"
           src="./assets/btn-fix-no-tran.png"
           alt="钱包乘车后即可参与">-->
      <img v-show="fixBthStatus===9" class="yui-fix-bth" src="./assets/btn-fix-equity-empty.png"
           alt="">


    </footer>

    <van-popup
        :closeable="true"
        :close-on-popstate="false"
        close-icon-position="top-left"
        @close="payPopupClose"
        v-model="payPopupShow">
      <div class="yui-popup">
        <div class="yui-popup-hd">
          <div class="yui-title">短信验证码</div>
        </div>
        <div class="yui-popup-bd">
          <div class="yui-popup-form">
            <label class="yui-input-box">
              <input class="yui-input"
                     type="tel"
                     ref="verifyCode"
                     id="verifyCode"
                     name="verifyCode"
                     maxlength="6"
                     v-model="verifyCode"
                     placeholder="验证码"
                     v-number-only>
            </label>

            <div class="yui-count-down">
              <van-count-down ref="countDown"
                              v-show="!countDownStatus"
                              millisecond
                              :time="countDownTime"
                              :close-on-click-overlay="false"
                              :closeable="true"
                              :auto-start="false"
                              @finish="countDownFinish"
                              format="sss"/>
              <van-button v-show="countDownStatus"
                          type="primary"
                          size="mini"
                          plain
                          @click="resendPay"
                          color="#dbc26d"
                          class="yui-btn-reset"> 重新发送
              </van-button>

            </div>


          </div>
          <p class="yui-pop-desc">验证码已发送{{ codePhone|phoneFilter }}</p>
        </div>
        <div class="yui-popup-ft"
             :class="{'yui-popup-ft_dis':verifyCode.length<6}"
             @click="confirmPay">
          确认
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
// import HelloWorld from './components/HelloWorld.vue'
import {activityPay, getActStatus, requestCdkey, sendVerifyCode, wangxin2Order, getWalletPhone} from "./services/api"
import {getSystemInfo} from './libs/tools'

export default {
  name: 'App',
  data() {
    return {
      payPopupShow: false,
      systemInfo: {},
      pageStatus: '',// --活动状态 01正在进行 00未开始 02已结束
      equity1Status: '',//--01已成功领取 00未领取 02领取失败 03 充值中
      equity2Status: '',//----01已成功领取 00未领取 02领取失败 03领取中
      payStatus: '', //--支付状态 Y成功 I支付中 N支付失败 U未支付
      userStatus: "", //--用户状态 01可参加活动（新用户） 02不可参加（老用户）00未开通
      equityCount: 0,
      token: '',
      deviceCoding: '',
      userPhone: '',
      userWalletPhone: '',
      activityNo: 'Q32FDKV566',// 活动编号 Q32FDKV566
      countDownTime: 60 * 1000,// 倒计时时长 60秒
      countDownStatus: false,// 倒计时状态
      verifyCode: '',//验证码
      verifyCodeToast: '',
      verifyCodeAjaxStatus: false,// 获取验证码页面请求状态
      confirmPayAjaxStatus: false, // 确认支付请求状态
      rechargeMobileNo: '',// 充值手机号
      rechargeMobileNoLog: '',// 充值手机号 记录值
      productId: 'SW10',// 网信产品编号:SW5    第四期SW10
      prepaidRefillAjaxStatus: false,// 话费充值 ajax状态
      equityAjaxStatus: false,// 权益二状态
      equity2CouponCode: '',//权益二 券码
      equity2ExpireTime: '',//权益2有效期
      csInfo: [],
      codePhone: '',
      phoneErroeMsg: '',
      equity1Count: '',
      equity2Count: '',
      // hasTrans: false,// 是否乘车
    }
  },
  directives: {
    numberOnly: {
      bind: function (el) {
        el.handler = function () {
          el.value = el.value.replace(/\D+/, '')
        }
        el.addEventListener('input', el.handler)
      },
      unbind: function (el) {
        el.removeEventListener('input', el.handler)
      },


    }
  },
  computed: {
    phoneState() {
      return /^1[3456789]\d{9}$/.test(this.rechargeMobileNo);
    },
    onPageStatus() {
      if (this.token === '') {
        return '未登录'
      } else if (this.pageStatus === '00') {
        return '活动未开始'
      } else if (this.pageStatus === '02') {
        return '活动已结束'
      } else if (this.userStatus === '00') {
        return '用户未开通'
      } else if (this.userStatus === '02') {
        return '非活动期间开通钱包'
      } else if (this.payStatus === 'I') {
        return '支付中'
      } else if (this.payStatus === 'N') {
        return '支付失败'
      } else if (this.payStatus === 'U') {
        return '未支付'
      } else if (this.payStatus === 'Y') {
        return '支付成功'
      } else {
        return ''
      }
    },
    joinDis() {
      if (this.token === '') {
        return true
      } else if (this.pageStatus === '00' || this.pageStatus === '02') {
        return true
      } else if (this.userStatus === '00' || this.userStatus === '02') {
        return true
      } else if (this.payStatus !== 'Y') {
        return true
      } else {
        return false
      }
    },
    fixBthStatus() {
      if (this.token === '') {
        //'未登录'
        return 0
      } else if (this.payStatus === 'Y') {
        //'支付成功'

        return 8

      } else if (this.pageStatus === '00') {
        //'活动未开始'
        return 2
      } else if (this.pageStatus === '02') {
        // '活动已结束'
        return 2
      } else if (this.equityCount === 0 && this.payStatus !== 'Y') {
        //'权益已经领完'
        return 9
      } else if (this.userStatus === '00') {
        //'用户未开通'
        return 3
      } else if (this.userStatus === '02') {
        //'非活动期间开通钱包'
        return 4
 /*     } else if (this.hasTrans === false) {
        // 用户未使用钱包乘车
        return 10*/
      } else if (this.payStatus === 'I') {
        //'支付中'
        return 5
      } else if (this.payStatus === 'N') {
        //'支付失败'
        return 6
      } else if (this.payStatus === 'U') {
        //'未支付'
        return 7
      } else if (this.payStatus === 'Y') {
        //'支付成功'

        return 8

      } else {
        return 0
      }
    },
    redEnvelopesDis() {
      if (this.token === '') {
        return true
      } else if (this.userStatus === '00') {
        return true
      } else {
        return false
      }
    }
  },
  watch: {},
  filters: {
    phoneFilter: function (tel) {
      // var tel = 19812311111;
      tel = "" + tel;
      // d表示数字0-9,{3}表示需要3个，所以d{3}就是表示3个数字
      var reg = /(\d{3})\d{4}(\d{4})/;
      //$1是第一个小括号里的 ,$2是第2个小括号里的
      return tel.replace(reg, "$1****$2")

    }
  },
  created() {

  },
  mounted() {
    // 友盟统计添加
    const script = document.createElement("script");
    script.src =
        "https://s95.cnzz.com/z_stat.php?id=1277875016&web_id=1277875016";
    script.language = "JavaScript";
    document.body.appendChild(script);
    window['iosGetInfo'] = (result) => {
      this.iosGetInfo(result)
    }

    // this.getPageStatus(this.token, this.deviceCoding)
    this.toGetUser()
  },
  methods: {
    toGetUser() {
      // if (this.$store.state.app.shell === 'bestugo') {
      let that = this
      getSystemInfo().then(res => {
        that.systemInfo = res
        if (res.system === 'ios') {

          window.webkit.messageHandlers.QDMETRO_H5_MESSAGE.postMessage("iosGetInfo")
        } else if (res.system === 'android') {
          let token = window.AndroidWebView.getTokenForH5();
          let deviceCoding = window.AndroidWebView.getDeviceCoding()
          let phone = window.AndroidWebView.getPhoneForH5()
          // resolve(systemInfo)
          if (token) {
            that.token = token;
            that.deviceCoding = deviceCoding
            that.userPhone = phone
            that.getPageStatus(token, deviceCoding)

          }
        }
      }).catch(err => {
        console.error(err)
      })

      // }
    },
    toGetUser2() {
      // if (this.$store.state.app.shell === 'bestugo') {
      let that = this
      getSystemInfo().then(res => {
        that.systemInfo = res
        if (res.system === 'ios') {

          window.webkit.messageHandlers.QDMETRO_H5_LOGIN_CALLBACK.postMessage("iosGetInfo")
        } else if (res.system === 'android') {
          let token = window.AndroidWebView.getTokenForH5();
          let deviceCoding = window.AndroidWebView.getDeviceCoding()
          let phone = window.AndroidWebView.getPhoneForH5()
          // resolve(systemInfo)
          if (token) {
            that.token = token;
            that.deviceCoding = deviceCoding
            that.userPhone = phone
            that.getPageStatus(token, deviceCoding)

          } else {
            window.AndroidWebView.loginForH5();
          }
        }
      }).catch(err => {
        console.error(err)
      })

      // }
    },
    iosGetInfo(obj) {
      console.log(obj)
      if (obj.user_is_login === "1") {
        this.token = obj.user_token;
        this.deviceCoding = obj.phone_device_coding;
        this.userPhone = obj.user_phone;
        this.getPageStatus(obj.user_token, obj.phone_device_coding)
      }


    },
    getPageStatus(token, deviceCoding) {
      let that = this
      if (window._czc) {

        window._czc.push(['_trackEvent', '一分购', '页面加载', '访问量', 1, '']);

      }
      let robj = new FormData()
      robj.append('token', token)
      robj.append('deviceCoding', deviceCoding)
      robj.append('activityNo', that.activityNo)
      getActStatus(robj).then(res => {
        console.log(res)
        that.csInfo.push('getActStatus=>' + JSON.stringify(res))
        if (res.respcod === '01') {
          that.pageStatus = res.data.activityStatus
          that.userStatus = res.data.userStatus
          that.payStatus = res.data.payStatus
          // that.hasTrans = res.data.hasTrans
          that.equityCount = res.data.count
          that.equity1Status = res.data.equity1.status
          that.equity2Status = res.data.equity2.status
          /*获取用户钱包手机号*/
          if (res.data.userStatus === '01' || res.data.userStatus === '02') {
            that.getUserWalletPhone(token, deviceCoding)
          }
          if (res.data.payStatus === 'Y') {
            this.$notify({
              message: '支付成功！已解锁权益',
              color: '#2a2832',
              background: '#ff9256',
              duration: 0
            });
          } else if (res.data.payStatus === 'I') {
            this.$notify({
              message: '支付中',
              color: '#2a2832',
              background: '#ff9256',
              duration: 0
            });
          }
          if (res.data.equity1.status === '01') {
            that.rechargeMobileNoLog = res.data.equity1.param
          } else if (res.data.equity1.status === '02') {
            that.rechargeMobileNo = res.data.equity1.param
            that.rechargeMobileNoLog = res.data.equity1.param
          } else if (res.data.equity1.status === '03') {
            that.rechargeMobileNoLog = res.data.equity1.param
          }


          if (res.data.equity2.status === '01') {
            // --01已成功领取 00未领取 02领取失败 03领取中
            that.equity2CouponCode = res.data.equity2.param
            that.equity2ExpireTime = res.data.equity2.expire
          }


        } else {

          this.$toast(res.respmsg);
        }

      })

    },

    getUserWalletPhone(token, deviceCoding) {
      let that = this
      if (window._czc) {

        window._czc.push(['_trackEvent', '一分购', '获取钱包手机号', '访问量', 1, '']);

      }
      let robj = new FormData()
      robj.append('token', token)
      robj.append('deviceCoding', deviceCoding)
      robj.append('activityNo', that.activityNo)
      getWalletPhone(robj).then(res => {
        console.log(res)
        if (res.respcod === '01') {
          that.userWalletPhone = res.data.phone
          that.rechargeMobileNo = res.data.phone
        } else {

          this.$toast(res.respmsg);
        }
      }).catch(err => {
        console.error(err)

        this.$toast('网络错误')
      })
    },

    /**
     * 跳转钱包
     * @returns {boolean}
     */
    toOpenWallet() {
      let startTime = Date.now()
      if (window._czc) {

        window._czc.push(['_trackEvent', '一分购', '跳转钱包', '', 1, '']);

      }
      if (this.systemInfo.shell === 'wechat') {
        window.location.href = "http://www.bestugo.com/metro/download.html"
      } else if (this.systemInfo.system === 'ios') {
        window.location.href = "com.qdmetro://wallet/index";
        if (this.systemInfo.shell === 'bestugo') return false;
        let interval = setInterval(function () {

          let endTime = Date.now();

          if (endTime - startTime < 5000) {

            window.location.href = "http://www.bestugo.com/metro/download.html";

            clearTimeout(interval);
          }

        }, 3000);
      } else if (this.systemInfo.system === 'android') {
        window.location.href = "com.qdmetro://wallet/index";
        if (this.systemInfo.shell === 'bestugo') return false;
        let interval = setInterval(function () {

          let endTime = Date.now();

          if (endTime - startTime < 7000) {

            window.location.href = "http://www.bestugo.com/metro/download.html";

            clearTimeout(interval);
          }

        }, 4000);
      }
    },
    cs() {
      this.$refs.countDown.reset()
      this.$refs.countDown.start();
    },
    /**
     * 获取验证码
     * 弹窗
     */
    toPay() {
      let that = this
      let startTime = Date.now()
      if (this.verifyCodeAjaxStatus) {
        return false
      }
      if (this.token === '') {

        if (this.systemInfo.shell === 'wechat') {
          if (window._czc) {

            window._czc.push(['_trackEvent', '一分购', '底部按钮跳转下载页面', '微信内打开', 1, '']);

          }
          window.location.href = "http://www.bestugo.com/metro/download.html"
        } else {
          // window.location.href = "com.qdmetro://wallet/index";
          if (this.systemInfo.shell !== 'bestugo') {
            if (window._czc) {

              window._czc.push(['_trackEvent', '一分购', '底部按钮', '浏览器打开', 1, '']);

            }
            // let onLoc=window.location.href
            window.location.href = "com.qdmetro://wallet/index"
            let interval = setInterval(function () {

              let endTime = Date.now();

              if (endTime - startTime < 5000) {

                window.location.href = "http://www.bestugo.com/metro/download.html";

                clearTimeout(interval);
              }

            }, 3000);
          } else {
            if (window._czc) {

              window._czc.push(['_trackEvent', '一分购', '底部按钮', '去登录', 1, '']);

            }
            this.toGetUser2()
          }
        }


      } else {
        if (window._czc) {

          window._czc.push(['_trackEvent', '一分购', '获取验证码', '', 1, '']);

        }
     /*   if (!that.hasTrans) {
          this.$toast('钱包乘车后方可参与本活动')
          return false
        }*/
        let rObj = new FormData()
        rObj.append('token', that.token)
        rObj.append('deviceCoding', that.deviceCoding)
        rObj.append('msgType', 1)
        that.verifyCodeAjaxStatus = true
        sendVerifyCode(rObj).then(res => {
          that.csInfo.push(JSON.stringify(res))
          that.verifyCodeAjaxStatus = false
          console.log(res)
          if (res.respcod === '01') {
            that.codePhone = res.data.phone
            that.payPopupShow = true
            that.countDownStatus = false
            setTimeout(function () {
              that.$refs.countDown.start()
              that.$refs.verifyCode.focus()
            }, 0)

          } else {
            this.$toast(res.respmsg);
          }
        }).catch(err => {
          console.error(err)
          that.verifyCodeAjaxStatus = false
          this.$toast('网络错误')
        })
      }
    },
    resendPay() {
      this.countDownStatus = false
      this.toPay()
    },
    /**
     * 倒计时结束
     */
    countDownFinish() {
      this.$refs.countDown.reset();
      this.countDownStatus = true
    },
    /**
     * 确认支付
     */
    confirmPay() {
      let that = this
      if (this.confirmPayAjaxStatus) {
        console.log('请求尚未完结')
        return false;
      }
      if (this.verifyCode === '') {
        this.verifyCodeToast = '验证码不可为空'
        console.log('验证码不可为空')
        return false;
      } else if (this.verifyCode.length < 6) {
        // this.verifyCodeToast = '请输入完整验证码'
        console.log('请输入完整验证码')
        return false;
      }
      if (window._czc) {

        window._czc.push(['_trackEvent', '一分购', '确认支付', '', 1, '']);

      }
      let rObj = new FormData()
      rObj.append('token', that.token)
      rObj.append('deviceCoding', that.deviceCoding)
      rObj.append('activityNo', this.activityNo)
      rObj.append('verifyCode', this.verifyCode)
      this.confirmPayAjaxStatus = true
      activityPay(rObj).then(res => {
        that.confirmPayAjaxStatus = false
        if (res.respcod === '01') {

          that.payStatus = res.data.payStatus
          that.$refs.countDown.reset()
          that.payPopupShow = false
          if (res.data.payStatus === 'Y') {
            this.$notify({
              message: '支付成功！已解锁权益',
              color: '#2a2832',
              background: '#ff9256',
              duration: 0
            });
          } else if (res.data.payStatus === 'I') {
            this.$notify({
              message: '支付中',
              color: '#2a2832',
              background: '#ff9256',
              duration: 0
            });
          } else if (res.data.payStatus === 'N') {
            this.$toast(res.data.desc,);
          }

        } else {
          this.$toast(res.respmsg);
          that.payPopupShow = false
        }
        console.log(res)
      }).catch(err => {
        that.confirmPayAjaxStatus = false
        console.error(err)
        this.$toast('网络错误')
      })
    },
    /**
     * 话费充值
     * @returns {boolean}
     */
    prepaidRefill() {
      let that = this
      if (this.prepaidRefillAjaxStatus) {
        return false;
      }
      if (!this.phoneState) {
        this.$toast('手机号格式错误')
        return false;
      }
      if (window._czc) {

        window._czc.push(['_trackEvent', '一分购', '话费充值', '', 1, '']);

      }



      let rObj = new FormData()
      rObj.append('token', that.token)
      rObj.append('deviceCoding', that.deviceCoding)
      rObj.append('activityNo', this.activityNo)
      rObj.append('rechargeMobileNo', this.rechargeMobileNo)
      rObj.append('productId', this.productId)
      rObj.append('type', 1)//	充值类型：1-话费
      wangxin2Order(rObj).then(res => {
        console.log(res)
        if (res.respcod === '01') {
          if (res.data.payStatus === '1') {
//--支付结果：1-下单成功（下单成功即为充值中状态，可能出现充值失败情况，以异步回调结果为准），2-下单失败
            this.$toast('下单成功')
            that.rechargeMobileNoLog = that.rechargeMobileNo
            that.equity1Status = '03'

          } else {
            this.$toast('下单失败')
          }
        } else {
          this.$toast(res.respmsg);
        }
      }).catch(err => {
        console.error(err)
        this.$toast('网络错误')
      })
    },
    /**
     *
     */
    toReceiveEquity2() {
      let that = this
      if (this.equityAjaxStatus) {
        return false;
      }
      if (window._czc) {

        window._czc.push(['_trackEvent', '一分购', '权益二领取', '', 1, '']);

      }
      let rObj = new FormData()
      rObj.append('token', that.token)
      rObj.append('deviceCoding', that.deviceCoding)
      rObj.append('activityNo', this.activityNo)
      this.equityAjaxStatus = true
      requestCdkey(rObj).then(res => {
        console.log(res)
        that.equityAjaxStatus = false
        if (res.respcod === '01') {
          that.equity2Status = res.data.status // --01已成功领取 00未领取 02领取失败 03领取中
          that.equity2CouponCode = res.data.param
          that.equity2ExpireTime = res.data.expire
        } else {
          this.$toast(res.respmsg);
        }
      }).catch(err => {
        console.error(err)
        that.equityAjaxStatus = false
        this.$toast('网络错误')
      })

    },
    equity2CouponCodeCopySuccess() {
      this.$toast('复制成功')
    },
    equity2CouponCodeCopyError() {
      this.$toast.fail('复制失败');
    },
    /**
     * 跳转到建行
     */
    toCCB() {
      if (window._czc) {

        window._czc.push(['_trackEvent', '一分购', '跳转到建行', '', 1, '']);

      }
      if (this.systemInfo.shell === 'bestugo') {
        if (this.systemInfo.system === 'ios') {
          window.webkit.messageHandlers.QDMETRO_H5_NATIVE_EXPLORER.postMessage("http://www.ccb.com/cn/html1/office/ebank/subject/19/jumpPg/index.html?funcid=01991001&businessid=qd00002020110501")
        } else {
          window.AndroidWebView.skipToBrowser("http://www.ccb.com/cn/html1/office/ebank/subject/19/jumpPg/index.html?funcid=01991001&businessid=qd00002020110501")
        }
      } else {
        window.location.href = "http://www.ccb.com/cn/html1/office/ebank/subject/19/jumpPg/index.html?funcid=01991001&businessid=qd00002020110501"
      }

    },
    /**
     * 手机号input获取焦点
     */

    phoneInputFocus() {
      if (this.equity1Status === '02') {
        this.equity1Status = '00'
      }
    },
    /**
     * 验证码弹窗关闭
     */
    payPopupClose() {
      this.verifyCode = ''
    }
  }
}
</script>

<style lang="less">
@default-w: 375px;
.convert(@px, @width: @default-w) {
  @var: unit(@px / @width) * 100;
  @vw: ~'@{var}vw';
}

.bg-image(@url) {
  background-image: ~"url(@{url})";
  background-repeat: no-repeat;
}

.yui-btn-reset {
  border-color: transparent !important;
  background-color: transparent !important;
}

#app {

  text-align: center;
  color: #595959;
  background-color: #d54a29;
  /*margin-top: 60px;*/
  background-image: url("./assets/banner-top-4.jpg");
  background-size: 100% auto;
  background-repeat: no-repeat;
  padding-top: 120vw;
}

.my-swipe .van-swipe-item {
  color: #fff;
  font-size: .convert(12px)[@vw];
  line-height: 150px;
  text-align: center;
  background-color: #39a9ed;
}

.footer-fix {
  position: fixed;
  bottom: 10vw;
  left: 0;
  right: 0;
  z-index: 1000;

  .yui-fix-bth {
    width: 94vw;
    height: 13vw;
  }
}

.yui-section {
  padding: 4vw;
  background-color: #e8e8e8;
}

#app .equoty-bth-1 {
  width: 78vw;
  height: 10vw;
  background-color: #eec37f;
  background-image: linear-gradient(180deg,
  #fc7650 0%,
  #ba3025 100%);
  box-shadow: 0 1vw 4vw 0 rgba(19, 18, 31, 0.2);
  border-radius: 6vw;
  border: none !important;
  color: #ffffff;
  font-size: 4vw;

  .van-button--small {
    color: #24242a;
    font-size: 4vw;
  }
}


.yui-cell {
  display: flex;
  align-items: center;
  padding: .convert(10px)[@vw];

  .yui-cell-hd {
    width: 4em;
  }

  .yui-cell-bd {
    flex: 1;

    .yui-input {
      max-width: 100%;
      border: none;
      font-size: 4vw;
      padding: 3vw 5vw;
      background-color: #f9ddd1;
      border-radius: 6vw;
      height: 5vw;
      line-height: 4vw;
      width: 68vw;
      color: #595959;

      &::placeholder {
        font-size: 4vw;
        line-height: 4vw;
        color: #b48e81;
      }

      &:disabled {
        opacity: 1 !important;
      }
    }
  }
}


.yui-header {
  width: 100%;
  display: block;
}

.yui-section {
  margin: 3vw 3vw 6vw;
  background-color: #fef4e8;
  border-radius: 3vw;
  color: #ffffff;

  .section-title {
    position: relative;

    span {
      position: relative;
      font-size: 5vw;

      &:before, &:after {
        position: absolute;
        content: " ";
        width: 15vw;
        height: 0.2vw;
        top: 50%;
        /*border-style: solid;*/
        /*border-width: 1px;*/


      }

      &:before {
        right: 140%;
        background: linear-gradient(90deg,
        rgba(178, 140, 90, 0.12) 0%,
        #b28c5a 100%);
      }

      &:after {
        left: 140%;
        background: linear-gradient(90deg,
        #b28c5a 0%,
        rgba(178, 140, 90, 0.12) 100%);
      }
    }
  }

  .section-desc {

    width: 48vw;
    height: 6vw;
    font-size: 6vw;
    font-weight: normal;
    font-stretch: normal;
    line-height: 3vw;
    letter-spacing: 0;
    color: #680000;
    margin: 5vw auto;
    position: relative;

    &:before {
      position: absolute;
      content: " ";
      background-color: #de3321;
      left: 0;
      right: 0;
      height: 2vw;
      bottom: 0.5vw;
      z-index: 0;
    }

    span {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;

    }
  }
}

#app .equity-1 {
  //background-image: url("./assets/bg-1-top-left.png"), url("./assets/bg-1-top-left.png");
  //background-repeat: no-repeat;
  position: relative;
  //background-position: 4vw 3vw, right bottom;
  //background-size: 18vw 18vw, 18vw 18vw;

  .equoty-bth-1.van-button--disabled {
    background: #c9c9c9;
    opacity: 1 !important;
    box-shadow: 0 1vw 4vw 0 rgba(19, 18, 31, 0.2);
    border-radius: 6vw;
  }
}

.equity-2 {
  .section-desc {
    width: 79vw;
  }

  .sec-2-banner {
    width: 86vw;
  }

  .download-jianhang {
    width: 46vw;
    height: 11vw;
    background-color: #e0a844;
    border-radius: 5vw;
    border: solid 0 #f2cc78;
    color: #24242a;
    font-size: 4vw;
  }


  .receive-success {
    position: relative;

    .receive-success-img {
      width: 100%;
    }

    .receive-success-bd {
      position: absolute;
      top: 11vw;
      left: 5vw;
      right: 5vw;
      bottom: 7vw;
      /*background-color: #ffffff;*/
      text-align: left;
      font-size: .convert(15px)[@vw];
      color: #24242a;

      .yui-btn-fz {
        background-color: transparent;
        padding: 0 2vw;
      }

      .yui-juanma {
        display: flex;
        align-items: center;
        padding-bottom: 1vw;

        .yui-bd {
          flex: 1;
        }
      }

      .yui-yxq {

      }
    }

    &.receive-success-2 {
      margin-bottom: 5vw;
      margin-top: 5vw;

      .sec-2-geted-title {
        position: absolute;
        top: -4vw;
        left: 28vw;
        width: 29vw;
      }

      .receive-success-bd {
        position: relative;
        background-color: #fceb99;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        border-radius: 3vw;
        padding: 4vw;

        .yui-juanma {
          align-items: flex-start;

          .yui-hd {
            width: 16vw;
            text-align: justify;
          }

          .yui-btn-fz {
            margin-left: 3vw;
          }
        }
      }
    }
  }


}

.yui_art {
  text-align: justify;
  margin-top: 10vw;

  h5 {
    font-size: 4vw;
    line-height: 3vw;
    color: #61170a;
    margin: 3vw 0;
  }

  p {
    margin: 2vw 0;
    font-size: 4vw;
    line-height: 6vw;
    color: #61170a;
  }
}


.yui-tx {
  text-align: justify;
  padding: 5vw 7vw 3vw;

  h5 {
    font-size: 4vw;
    font-weight: 600;

    line-height: 3vw;
    color: #dbbe82;
    margin: 0;
  }

  p {
    font-size: 4vw;

    line-height: 6vw;
    color: #dbbe82;
  }
}

.yui-mzsm {
  text-align: justify;
  padding: 2vw 7vw 23vw;

  h5 {
    font-size: 4vw;
    line-height: 3vw;
    color: #8e886f;
    margin: 0;
  }

  p {
    font-size: .convert(15px)[@vw];
    font-weight: normal;
    font-stretch: normal;
    line-height: 5vw;
    color: #8e886f;
  }
}


#app .van-popup {
  background-color: transparent;
}

.yui-popup {
  width: 81vw;
  height: 49vw;
  background-color: #ffffff;
  border-radius: 3vw;
  display: flex;
  flex-direction: column;

  .yui-popup-hd {
    /*display: flex;*/
    padding: 3vw 0 2vw;

    .yui-title {
      font-size: 4vw;
      color: #595959;
    }
  }

  .yui-popup-bd {
    flex: 1;

    .yui-popup-form {
      display: flex;
      align-items: center;
      width: 68vw;

      background-color: #f0f0f0;
      border-radius: 1vw;
      margin: 3vw auto;

      .yui-input-box {
        flex: 1;
        padding: 3.5vw 3vw;
        height: 5vw;
        //line-height: 12vw;

      }

      .yui-input {

        background-color: transparent;
        border: none;
        width: 100%;
        font-size: 4vw;
        color: #b3b3b3;
        line-height: 1;

        &::placeholder {
          font-size: 4vw;
          color: #b3b3b3;
        }
      }

      .yui-count-down {
        min-width: 7vw;
        position: relative;
        padding: 0 3vw;
        font-size: 4vw;
        color: #b3b3b3;

        &:before {
          position: absolute;
          content: " ";
          left: 0;
          top: -1vw;
          bottom: -1vw;
          border-left: 0.3vw solid #d4d4d4;
        }
      }
    }
  }

  .yui-popup-ft {
    /*width: 81vw;*/
    height: 13vw;
    background-color: #dbc26d;
    border-radius: 1vw;

    font-size: 4vw;
    line-height: 13vw;

    color: #35324a;

    &.yui-popup-ft_dis {
      background-color: #bcbcbc;
      color: #fff;
    }
  }

}

.yui-pop-desc {
  font-size: 3vw;
  color: #999999;
}

.yui-equity1-success {
  width: 72vw;
  padding: 3vw 0;
  background-color: #34343c;
  border-radius: 3vw;
  margin: 3vw auto;
  color: #ffad4c;

  .yui-icon {
    font-size: 5vw;
  }

  p {
    margin: 0;
    font-size: .convert(14px)[@vw];
  }
}

.equity1Status_03 {
  margin: 1vw 0 2vw;
  font-size: 3vw;
  line-height: 3vw;
  color: #ffad4c;
}

.equity1Status_02 {
  font-size: 3vw;
  line-height: 3vw;
  color: #ff4c4c;
  margin: 1vw 0 2vw;
}
</style>
